import React from 'react';
import Notes from './Notes';
import '../../CommonCSS/SocietyCSS.css';

const NotesApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5> Notes</h5>
          </div>
        </div>
        <Notes/>
      </div>
    </div >
  );
};

export default NotesApp;
